import React from 'react';
import {
  CASH_DISTRIBUTION_OPTIONS,
  APPLICATION_POINT_OPTIONS,
  CORPORATE_ACTIONS_METHODOLOGY,
  CORPORATE_ACTIONS_METHODOLOGY_OPTIONS,
  DISSEMINATION_OPTIONS,
  DISSEMINATION_OPTIONS_ARRAY,
  PRICE_RETURN,
} from '../../../utils/constants';
import IndexSlider from '../components/SliderTickers/IndexSlider';
import BitaSelect from '../../../../../components/BitaSelect/BitaSelect';
import { useFieldRefContext } from '../../../../../bitaHooks';
import styles from '../components/ParametersForm.module.scss';
import './AdditionalParametersContent.scss';

const AdditionalParametersContent = ({
  errors,
  sliderBaskets,
  selectedBasketsData,
  selectedIndex,
  setSelectedIndex,
  handleUpdateProperty,
}) => {
  const { registerFieldRef } = useFieldRefContext();
  const data = selectedBasketsData.find(ticker => ticker.symbol === selectedIndex) ?? {};
  // Find the matching cash distribution option
  const selectedCashDistribution = data?.additional_settings?.m_cash_distribution_type?.name
    ? CASH_DISTRIBUTION_OPTIONS.find(
        item => item.name === data?.additional_settings?.m_cash_distribution_type?.name.toString(),
      )
    : null;

  // Find the matching application point option
  const selectedApplicationPoint = data?.additional_settings?.cash_distribution_application_point
    ? APPLICATION_POINT_OPTIONS.find(
        item => item.id === data?.additional_settings?.cash_distribution_application_point,
      )
    : null;
  const showCashDistribution = data?.calculation_type !== PRICE_RETURN;

  // Handle cash distribution selection
  const handleCashDistributionChange = selectedValue => {
    if (!selectedValue || !handleUpdateProperty) return;

    const updatedData = selectedBasketsData.map(basket =>
      basket.symbol === selectedIndex
        ? {
            ...basket,
            additional_settings: {
              ...basket.additional_settings,
              m_cash_distribution_type: {
                id_m_cash_distribution_type: parseInt(selectedValue.id, 10),
                name: CASH_DISTRIBUTION_OPTIONS.find(option => option.id === selectedValue.id).name,
              },
            },
          }
        : basket,
    );

    handleUpdateProperty(updatedData);
  };

  // Handle application point selection
  const handleApplicationPointChange = selectedValue => {
    if (!selectedValue || !handleUpdateProperty) return;

    const updatedData = selectedBasketsData.map(basket =>
      basket.symbol === selectedIndex
        ? {
            ...basket,
            additional_settings: {
              ...basket.additional_settings,
              cash_distribution_application_point: selectedValue.id,
            },
          }
        : basket,
    );

    handleUpdateProperty(updatedData);
  };

  return (
    <>
      <div className="additional-parameters-content-wrapper">
        <div className="additional-parameters-tab-container">
          <IndexSlider
            indexes={sliderBaskets ?? []}
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
          />

          <div className="additional-parameters-section-title">CORPORATE ACTIONS METHODOLOGY</div>

          <div className="additional-parameters-main-page-container">
            <div style={{ display: 'flex' }}>
              {' '}
              {CORPORATE_ACTIONS_METHODOLOGY_OPTIONS.map(button => (
                <div key={button}>
                  <input
                    id={button}
                    type="radio"
                    name="radio-filter-tables-corporate-actions-methodology"
                    onChange={() => {}}
                    disabled={button === CORPORATE_ACTIONS_METHODOLOGY.CUSTOM}
                    defaultChecked={button === CORPORATE_ACTIONS_METHODOLOGY.BITA}
                  />
                  <label htmlFor={button}>{button}</label>
                </div>
              ))}
            </div>
          </div>
        </div>
        {showCashDistribution && (
          <div className="additional-parameters-tab-container">
            <div className="additional-parameters-section-title">CASH DISTRIBUTION</div>
            <div className="additional-parameters-main-page-container">
              <div>Cash Distributions</div>

              <div className="cash-distribution-container">
                <div
                  className={styles.parametersPickerContainerAdditionalParameters}
                  id="field-cash_distribution"
                  ref={registerFieldRef('cash_distribution')}
                >
                  <BitaSelect
                    width="330px"
                    label="Select a Cash Distribution"
                    selected={data?.additional_settings?.m_cash_distribution_type?.name}
                    value={selectedCashDistribution}
                    data={CASH_DISTRIBUTION_OPTIONS}
                    handleSelection={handleCashDistributionChange}
                  />
                  {errors[data?.symbol]?.cash_distribution && (
                    <div className={styles.errorMessageStaticPosition}>
                      {errors[data?.symbol]?.cash_distribution}
                    </div>
                  )}
                </div>
                <div
                  className={styles.parametersPickerContainerAdditionalParameters}
                  id="field-cash_distribution_application_point"
                  ref={registerFieldRef('cash_distribution_application_point')}
                >
                  <BitaSelect
                    width="330px"
                    label="Select an Application Point"
                    selected={data?.additional_settings?.cash_distribution_application_point}
                    value={selectedApplicationPoint}
                    data={APPLICATION_POINT_OPTIONS}
                    handleSelection={handleApplicationPointChange}
                  />
                  {errors[data?.symbol]?.cash_distribution_application_point && (
                    <div className={styles.errorMessageStaticPosition}>
                      {errors[data?.symbol]?.cash_distribution_application_point}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="additional-parameters-tab-container">
          <div className="additional-parameters-section-title">DISSEMINATION OPTIONS</div>

          <div className="additional-parameters-main-page-container">
            {' '}
            <div style={{ display: 'flex' }}>
              {' '}
              {DISSEMINATION_OPTIONS_ARRAY.map(button => (
                <div key={button}>
                  <input
                    id={button}
                    type="radio"
                    name="radio-filter-tables-dissemination-options"
                    onChange={() => {}}
                    disabled={button === DISSEMINATION_OPTIONS.COMBINED}
                    defaultChecked={button === DISSEMINATION_OPTIONS.BITA}
                  />
                  <label htmlFor={button}>{button}</label>
                </div>
              ))}
            </div>
            {/* {
							disseminationOptionsType === BITAANDNLOOMBERD &&
							<BloombergContent 
								bloombergOptions={indexMetadata?.openingInfo?.bloombergOptions ?? {}} 
								setBloombergOptions={handleBloomberOptions}
							/>
						} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdditionalParametersContent;
